import React from 'react';

export const PersonDescriptionAndEmail = ({ personDescription, email, style }) => {
  let description = '';
  if (personDescription && personDescription != null && personDescription !== '') {
    description = personDescription;
  } else if (email && email != null && email !== '') {
    description = email;
  }
  if (email && email != null && email !== '') {
    description += ` <${email}>`;
  }

  return <div style={style}>{description}</div>;
};
